import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/germany.geojson";

const REGIONS = [
    { code: "Baden-Württemberg", name: "Baden-Württemberg" },
    { code: "Bayern", name: "Bayern" },
    { code: "Berlin", name: "Berlin" },
    { code: "Brandenburg", name: "Brandenburg" },
    { code: "Bremen", name: "Bremen" },
    { code: "Hamburg", name: "Hamburg" },
    { code: "Hessen", name: "Hessen" },
    { code: "Mecklenburg-Vorpommern", name: "Mecklenburg-Vorpommern" },
    { code: "Niedersachsen", name: "Niedersachsen" },
    { code: "Nordrhein-Westfalen", name: "Nordrhein-Westfalen" },
    { code: "Rheinland-Pfalz", name: "Rheinland-Pfalz" },
    { code: "Saarland", name: "Saarland" },
    { code: "Sachsen", name: "Sachsen" },
    { code: "Sachsen-Anhalt", name: "Sachsen-Anhalt" },
    { code: "Schleswig-Holstein", name: "Schleswig-Holstein" },
    { code: "Thüringen", name: "Thüringen" },
];

const REGION_CODES = REGIONS.map(r => r.code);

const GermanyMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 2700, center: [10.5, 51.2] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="germany"
            analyticsLocationType="germany"
            trackingLabel="Germany Map"
            storageKey="germany_map"
            title="🇩🇪 Germany Travel Map"
            subtitle="Click on German Länder you've visited. Or use the checklist below!"
            items={REGIONS.map(r => ({ id: r.code, name: r.name }))}
            noun="Länder"
            unitLabel="Länder"
            captionUnit="German Länder"
            share={{
                region: 'Germany',
                fileName: 'visited-germany-map.png',
                trackId: 'germany'
            }}
            renderMap={renderMap}
        />
    );
};

export default GermanyMapSection;
